var map = {
	"./info_1.png": "7Nkm",
	"./info_2.png": "okz3",
	"./info_3.png": "WVNt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2mgb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home ^\.\/info_.*\.png$
// module id = 2mgb
// module chunks = 1